export default __webpack_public_path__ + "57a3cac8252300430ee09ba481f588d9.png";